import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

export default function RecoveryRedirect() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const hasRecoveryHash = location.hash.includes("type=recovery");
    const searchParams = new URLSearchParams(location.search);
    const hasRecoveryQuery = searchParams.get("type") === "recovery" || !!searchParams.get("code");
    if (!hasRecoveryHash && !hasRecoveryQuery) return;
    if (location.pathname === "/reset") return;
    navigate(
      { pathname: "/reset", search: location.search, hash: location.hash },
      { replace: true }
    );
  }, [location.hash, location.pathname, location.search, navigate]);

  return null;
}
